import React, { useEffect, useState } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { Loader2, LogIn } from "lucide-react";
import { toast } from "sonner";
import SEO from "../../components/site/SEO";
import { useAuth } from "../../lib/auth";
import { formatApiErrorDetail } from "../../lib/apiClient";
import { T } from "../../lib/testIds";
import Logo from "../../components/site/Logo";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => { if (user && user.id) navigate("/admin", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setSubmitting(false); }
  };

  if (user && user.id) return <Navigate to="/admin" replace />;

  return (
    <>
      <SEO title="Admin Login — Wonder Washers" />
      <div className="min-h-screen grid md:grid-cols-2">
        <div className="hidden md:flex bg-[color:var(--ww-navy)] text-white p-12 flex-col justify-between relative overflow-hidden ww-water-bg">
          <div className="relative z-10">
            <Logo variant="white-on-dark" size="md" />
          </div>
          <div className="relative z-10">
            <h1 className="font-display uppercase text-5xl leading-none">Welcome back<br /> to the console.</h1>
            <p className="mt-3 text-slate-300">Dashboard, calendar, pipeline, inbox, and automations — all in one place.</p>
          </div>
          <div className="relative z-10 text-xs text-slate-400">© {new Date().getFullYear()} Wonder Washers Pressure Washing</div>
          <div className="absolute -right-24 -bottom-24 h-96 w-96 rounded-full bg-[color:var(--ww-red)]/15" />
        </div>
        <div className="flex items-center justify-center p-8">
          <form onSubmit={submit} className="w-full max-w-md">
            <div className="md:hidden mb-8"><Logo size="md" /></div>
            <h2 className="font-display uppercase text-4xl text-[color:var(--ww-navy)]">Sign in</h2>
            <p className="text-slate-600 mt-2">Use your Wonder Washers credentials.</p>
            <div className="mt-8 space-y-4">
              <div>
                <label className="text-xs font-subhead text-slate-600 uppercase tracking-wider">Email</label>
                <input data-testid={T.login.email} type="email" required autoFocus autoComplete="username" className="ww-input mt-1" value={email} onChange={e => setEmail(e.target.value)} />
              </div>
              <div>
                <label className="text-xs font-subhead text-slate-600 uppercase tracking-wider">Password</label>
                <input data-testid={T.login.password} type="password" required autoComplete="current-password" className="ww-input mt-1" value={password} onChange={e => setPassword(e.target.value)} />
              </div>
              {error && <div data-testid={T.login.error} className="ww-badge-red">{error}</div>}
              <button data-testid={T.login.submit} type="submit" disabled={submitting} className="ww-btn-primary w-full inline-flex items-center justify-center gap-2">
                {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : <LogIn className="h-4 w-4" />} Sign in
              </button>
            </div>
            <div className="mt-6 text-xs text-slate-500">
              Owner: <span className="font-mono">dane@op1776.com</span>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
